export default __webpack_public_path__ + "static/media/Logo_image_2020_08_09T19_10_48_290Z.35334787.png";